var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{key:'composition-api-code-organization'},[_c('img',{staticClass:"code-organization",attrs:{"src":"/images/code-organization.jpg","loading":"lazy"}})])}
var staticRenderFns = []

export { render, staticRenderFns }